export function filterSpcifications(arr,key){
    // Use loose equality to handle string/number mismatch
    return arr.filter((l) => l.key == key);
}